import React, { useEffect, useContext, useState } from 'react';
import classNames from 'classnames';
import { getPendantColor } from '../../utils/color';
import { getPageSameType, toTop } from '../../utils/util';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import intl from 'react-intl-universal';
import { ThemeContext } from '../../store/ThemeProvider';
import NormalButton from './NormalButton';
import stat from '../../utils/stat';

interface IRedpackageButton {
  rootStore?: RootStore;
}

const RedpackageButton = (props: IRedpackageButton) => {
  const { redPackStore } = props.rootStore!;
  const onRedpackgeClick = () => {
    redPackStore.setSendModal(true);
    stat.event('button_redpackage');
  };

  return (
    <NormalButton className="pendant-redpackage" onClick={onRedpackgeClick}>
      <img src={require('../../assets/icon-redpackage.png')} />
    </NormalButton>
  );
};

export default inject('rootStore')(observer(RedpackageButton));
